export interface ISubmitData {
  phoneNumber: string;
  isAgree: boolean;
  stringNumber: string;
  query?: {
    [key: string]: string;
  };
}

export enum StoreEnum {
  appStore = "appStore",
  googleStore = "googleStore",
  ruStore = "ruStore",
  website = "website",
}

interface ILinkButton {
  url: string;
  type: StoreEnum;
  logo: string;
}

export interface IReferalViewData {
  userData: null | ISubmitData;
  isSuccess: boolean;
  isLoading: boolean;
  showError: boolean;
  buttonLinks: ILinkButton[] | [];
}
